import { customFetchProcess } from "~/composables/customFetch";

export function useCustomFetch(endpoint: string, options: any = {}) {
  return customFetchProcess(endpoint, options, true);
}
